"use client"

import { CounterBadge } from "@/app/nft/counter/badge"
import { reatomComponent } from "@reatom/react"
import { useCollectionItemsOwnedByUserCountReatom } from "../store/hooks.reatom"

export const UserNftsCounterBadgeReatom = reatomComponent(() => {
  const count = useCollectionItemsOwnedByUserCountReatom()

  return (
    <CounterBadge
      data-testid="user-owned-nfts-amount"
      data-amount={count}
      count={count}
    />
  )
}, "UserNftsCounterBadgeReatom")
